import { Grid } from "@mui/material";
import { FC, useState } from "react";
import useStyles from "./leadEstimateStyle";
import LeadEstimateForm from "./LeadQuoteForm";
import { useSelector } from "react-redux";
import AlertOpenQuote from "./AlertOpenQuote";
import CustomButton from "../../../../components/common/button/CustomButton";

const LeadQuote: FC<any> = ({ screenType = "quotation" }) => {
  const [show, setShow] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const classes = useStyles({ show });
  const { leadDetails } = useSelector((state: any) => state.lead);

  const closeAlertModel = () => {
    setAlertShow(false);
  };

  // Helper function to handle button click
  const handleButtonClick = () => {
    if (screenType === "quotation") {
      switch (leadDetails?.lead?.status) {
        case "NEW LEAD":
        case "ESTIMATES":
          setAlertShow(true); // Show alert for "NEW LEAD" status
          break;
        case "SURVEY":
          if (leadDetails?.lead?.survey_status === "COMPLETED") {
            setShow(true);
          } else {
            setAlertShow(true);
          }
          break;
        default:
          setShow(true); // Open the form for other statuses
      }
    } else {
      setShow(true); // Default behavior for other screen types
    }
  };

  return (
    <>
      <AlertOpenQuote
        open={alertShow}
        title={"Alert"}
        onHide={closeAlertModel}
        setAlertModelShow={setAlertShow}
        setShow={setShow}
      />
      <Grid item xs={12} md={2.4} >
        <CustomButton
          style={{ padding: "10px 30px", height: "36px", width: "100%" }}
          title={screenType === "quotation" ? "Quote" : "Estimate"}
          onClick={() => {
            screenType === "quotation" ? handleButtonClick() : setShow(true);
          }}
          disabled={
            screenType === "quotation"
              ? leadDetails?.lead?.survey_status === "COMPLETED"
                ? false
                : false
              : false
          }
        />
        {/* <PageTitle
          title={''}
          button={screenType === "quotation" ? "Quote" : "Estimate"}
          onClick={() => {
            screenType === "quotation" ? handleButtonClick() :setShow(true);
          }}
          btnDisabled={
            screenType === "quotation"
              ? leadDetails?.lead?.survey_status === "COMPLETED"
                ? false
                : false
              : false
          }
        /> */}
      </Grid>

      {show && (
        <section className={show ? classes.estimatePopupOverlay : ''}>
        <LeadEstimateForm
          show={false}
          setShow={setShow}
          screenType={screenType}
        />
        </section>
      )}
      </>
  );
};

export default LeadQuote;
